// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"_3cLpA","hidden":"_3EhiK","buttonWrapper":"_1dHd9","downloadButton":"_jRDF","icon_small":"_2Kt2M","iconSmall":"_2Kt2M","icon_big":"_3yth0","iconBig":"_3yth0"};